var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"max-w-2xl mx-auto min-height"},[_c('keep-alive',{attrs:{"include":_vm.$store.getters.keepAlives}},[_c('router-view')],1)],1),(_vm.$route.meta.hasFooter)?_c('Footer'):_vm._e(),(_vm.$route.meta.hasTabbar)?_c('Tabbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }